export class ClienteCierre {
    TipoVenta: number;
    TipoPago: number;
    Rancho: string;
    Cuenta_SGC: string;
    ClienteNombre: string;
    ClienteCUIT: string;
}